// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.supplier-page[data-v-ea7c429e] { padding: 16px;\n}\n.card-title[data-v-ea7c429e] { font-size: 16px; font-weight: 600;\n}\n.stat-card[data-v-ea7c429e] { text-align: center; cursor: default;\n}\n.stat-label[data-v-ea7c429e] { font-size: 13px; color: #909399; margin-bottom: 8px;\n}\n.stat-value[data-v-ea7c429e] { font-size: 22px; font-weight: bold; color: #303133;\n}\n", ""]);
// Exports
module.exports = exports;
